import React from 'react';
import GxList from '../../gx/GxList';
import { useTranslation } from '../../hx/useTranslation';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
import * as FxTable from '../../fx/FxTable';
import { useNav } from '../../hx/useNav';
import { useWindowSize } from '../../hx/useWindowSize';
import { clearStore, StoreClient, StoreRepl } from "../../gx/GxStore";
import { useSessionStorage } from '../../hx/useSessionStorage';
import GxDlgSelectClient from '../../gx/GxDlgSelectClient';
import GxIconButtonLastClient from '../../gx/GxIconButtonLastClient';


const MxActivityOptiR = (props) => {
  const [{ trans }] = useTranslation();
  const [{ navTo }] = useNav();

  const size = useWindowSize();
  const [storeClient, setStoreClient] = useSessionStorage('StoreClient', StoreClient);
  const [storeRepl, setStoreRepl] = useSessionStorage('StoreRepl', StoreRepl);
  
  const r_list = React.useRef(null);
  const r_dlg_select_client = React.useRef(null);

  const hasColumnBranchId = () => { return Boolean(localStorage.getItem('MxActivityOptiR.addcol_txBranchId') === '1') };

  const [, updateState] = React.useState();
  const forceUIUpdate = React.useCallback(() => updateState({}), []);

  React.useEffect(() => {
    clearStore('StoreRepl', storeRepl);
    // eslint-disable-next-line
  }, []);

  const openForm = async (op, row) => {
    if (row === null) {
      r_dlg_select_client.current.setIntermediateValues({});
      r_dlg_select_client.current.setOpen(true);
    } else {
      FxLog.infox('MxActivityOptiR.openForm', '...row:', row);
      storeClient.inClient = row.original.inClient;
      storeClient.txClient = row.original.txClient;
      Promise.all([setStoreClient(storeClient)]).then((result) => {
        FxLog.infox('MxActivityOptiR.openForm', '...storeClient:', storeClient);
        storeRepl.inRepl = row.original._id;
        storeRepl.boComm = row.original.hasComm;
        setStoreRepl(storeRepl);
        navTo("client-repl-form");
      });
    }
  }

  const getTableColumns = () => {
    let cols = [];
    let id = -1;
    try{
    cols.push({ id: id++, Header: "ID", accessor: "_id", show: false });
    cols.push({ id: "inClient", Header: "inClient", accessor: "inClient", show: false });
    cols.push({ id: "txBranchId", Header: trans('field.branch_id'), accessor: "txBranchId", highlight: true, width: '5%', show: hasColumnBranchId() });
    cols.push({ id: id++, Header: trans('field.client'), accessor: "txClient", highlight: true, width: '20%' });
    cols.push({ id: id++, Header: trans('field.date'), accessor: "dtFrom", highlightDate: true, width: '10%' });

    if (size.isLarge) { // PANTALLA GRANDE
      cols.push({ id: id++, Header: trans('field.next'), accessor: row => (FxTable.cellToLocalDate(row["dtNext"])), width: '10%' });
      cols.push({ id: id++, Header: trans('field.ps'), accessor: "txPs", highlight: true, width: '50%' });
      cols.push({ id: id++, Header: trans('field.comm_s'), accessor: row => (row["hasComm"]==='1' ? trans('field.yes') : trans('field.no')), width: '5%' });

    } else { // PANTALLA PEQUEÑA
    }

    cols.push({ id: "A", Header: "not_pending", accessor: row => Boolean(row["_inReplNextSimilar"]), show: false });
    return cols;

    } catch(error) {
      FxLog.errorx('MxActivityOptiR.getTableColumns', error)
    }
    return cols;
  }

  const getTooltip = () => {
    let tip = `${trans('field.client')} / ${trans('field.date')} / ${trans('field.ps')}`;
    if (hasColumnBranchId()) tip = tip + `${' / ' + trans('field.branch_id')}`;
    return tip;
  }

  const getTableOptionalCols = () => {
    let cols = [];
    cols.push({ id: 'txBranchId', name: trans('field.branch_id') + " +🔍︎", checked: hasColumnBranchId() ? '1' : '0' });
    return cols;
  }

  const optionsSelected = (options) => {
    localStorage.setItem('MxActivityOptiR.addcol_txBranchId', options.includes('txBranchId') ? '1' : '0');
    r_list.current.getTable().setTooltipText(getTooltip());
    r_list.current.getTable().clearSearch();
    forceUIUpdate();
  }

  return (
    <div>
      <GxList
        moduleName={`${trans('field.activity')}: ${trans('field.repls')}`}
        xref={r_list}
        tooltip={`${trans('field.client')} / ${trans('field.date')} / ${trans('field.ps')}`}
        fullscreen
        url={`activity/opti/typelist/r`}
        onOpenForm={openForm}
        refColors={['table_cell_color_black|' + trans('field.pending')]}
        columns={getTableColumns()}
        optionalColumns={getTableOptionalCols()}
        onOptions={optionsSelected}
        optionalFromTo={true}
        optionalFromToButtonToday={true}
        optionalFromToButtonLast7Days={true}
        optionalFromToButtonLast30Days={true}
        addToolbarButtons={
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <GxIconButtonLastClient theList={r_list} />
          </div>
        }
        speechExternal
      />

      <GxDlgSelectClient xref={r_dlg_select_client} 
        includeAnimal={true}
        onSelect={(row, intermediateValues) => {
          FxLog.infox('MxActivityOptiR.return.GxDlgSelectClient', '...row:', row);
          Promise.all([setStoreClient(storeClient)]).then((result) => {
            openForm(null, row);
          });
        }} 
      />

    </div>
  );

}

export default MxActivityOptiR;